export default class ExtensionErrorCodes {

/**
 * Returns true if based on the nature of the error, we can still fallback to using the "light" Kiosk Mode Check.
 * @param errorList
 */
static isRecoverableError = (errorList: string[]) => {
    if (ExtensionErrorCodes.isTechnicalError(errorList)
        || errorList.includes("KIOSK_VERIFICATOR_NOT_AVAILABLE_FOR_MANAGED_DEVICE")
        || errorList.includes("MANAGED_DEVICE_CONFIGURATION_UNAVAILABLE")) {
        return true;
    }
    return false;
}

static isTechnicalError = (errorList: string[]) => {
    return errorList.includes("EXTENSION_TIMED_OUT")
        || errorList.includes("KIOSK_VERIFICATOR_ERROR_IN_EXTENSION");
}

static appendParamForStrictFallback = (errorList: string[], marketplaceId?: string): string => {
    if (ExtensionErrorCodes.isTechnicalError(errorList)) {
        return marketplaceId ? '&diagnosis=FALLBACK_UPON_STRICT_CHECK_ERROR': 'diagnosis=FALLBACK_UPON_STRICT_CHECK_ERROR';
    }
    return '';
}
}
